export default __webpack_public_path__ + "static/media/MM.89b07e7f.svg";